/**
 * User Created Success Dialog Component
 * Shows Account ID and email delivery status after creating a new user
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box,
  IconButton,
  Tooltip,
  Stack
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function UserCreatedDialog({ open, data, onClose }) {
  const handleCopy = () => {
    if (data?.accountId) {
      navigator.clipboard.writeText(data.accountId);
    }
  };

  const formattedAccountId = data?.accountId?.replace(/(\d{4})(\d{4})(\d{4})/, '$1 $2 $3');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircleIcon color="success" />
        User Created Successfully
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Alert severity="success">
            User {data?.email} has been created
          </Alert>

          <Box sx={{
            bgcolor: 'grey.100',
            p: 2,
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}>
            <Typography variant="body2" color="text.secondary">
              Account ID
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant="h6"
                sx={{
                  fontFamily: 'monospace',
                  letterSpacing: 2,
                  flex: 1
                }}
              >
                {formattedAccountId}
              </Typography>
              <Tooltip title="Copy Account ID">
                <IconButton
                  size="small"
                  onClick={handleCopy}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {data?.emailSent ? (
            <Alert severity="success" icon={<CheckCircleIcon />}>
              Account ID has been emailed to <strong>{data?.email}</strong>
            </Alert>
          ) : (
            <Alert severity="warning" icon={<WarningIcon />}>
              <strong>Email delivery failed.</strong> Please manually provide the Account ID to the user.
            </Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
